import { colorsList } from "../../data/colorsList";

export default function HistoryTableHeader({ lapsus }) {
  return (
    <thead>
      <tr
        style={{
          color: colorsList.white,
        }}
      >
        {lapsus.map((e, index) => (
          <td
            key={index}
            style={{
              textAlign: "center",
              width: `${100 / lapsus.length}%`,
              backgroundColor: e.current
                ? colorsList.darkGreen
                : colorsList.blue,
            }}
          >
            {e.name}
          </td>
        ))}
      </tr>
    </thead>
  );
}
